import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const styles = makeStyles(() => ({
  reportSubheader: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "20px",
    color: getBrandCustom("primaryColor", "#308CDB"),
  },
  reportFavorite: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "14px",
    color: getBrandCustom("primaryColor", "#308CDB"),
    cursor: "pointer",
  },
  reportFavoriteContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "8px 16px",
    gap: "12px",
    border: "1px solid #EDF5FB",
    borderRadius: "8px",
  },
  reportFavoriteItems: {
    margin: "16px 0 24px 0",
  },
  favoritesEmpty: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "150%",
    color: "#98A2B3",
  },
  skeleton: {
    transform: "none",
    width: "100%",
    height: 52,
    marginBottom: "42px",
  },
  reportFavoriteWrapper: {
    padding: "8px 16px 8px 0 !important",
  },
  favoriteIcon: {
    padding: "5px",
  },
}));

export default styles;
